import { render, staticRenderFns } from "./modalAlterarDataEncaixe.vue?vue&type=template&id=24480130&"
import script from "./modalAlterarDataEncaixe.vue?vue&type=script&lang=js&"
export * from "./modalAlterarDataEncaixe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports